import type { ComponentMultiStyleConfig } from "@chakra-ui/react"

// .bns-choice: 18px box, line-strong border, red once checked (accent).
const focusRing = {
  outline: "2px solid",
  outlineColor: "focus",
  outlineOffset: "2px",
}

export const Checkbox: ComponentMultiStyleConfig = {
  parts: ["icon", "container", "control", "label"],
  baseStyle: {
    control: {
      bg: "surface",
      borderWidth: "1px",
      borderColor: "lineStrong",
      borderRadius: "sm",
      _hover: {
        borderColor: "text",
      },
      _focusVisible: focusRing,
      _checked: {
        bg: "accent",
        borderColor: "accent",
        color: "onAccent",
        _hover: { bg: "accentHover", borderColor: "accentHover" },
        _disabled: { bg: "line", borderColor: "line", color: "textSubtle" },
      },
      _indeterminate: { bg: "accent", borderColor: "accent", color: "onAccent" },
    },
    label: {
      color: "text",
    },
  },
  sizes: {
    md: {
      control: { w: "18px", h: "18px" },
      label: { fontSize: "sm" },
    },
    sm: {
      control: { w: "16px", h: "16px" },
      label: { fontSize: "xs" },
    },
  },
}
